import { useTranslations } from 'next-intl'

import { Button, Spinner } from '@/shared/ui'

import { useTossWidget } from '../../lib/toss-widget'

export const PaymentButton = () => {
  const t = useTranslations('card_payment')

  const { isWidgetReady, requestPayment, confirmPayment, isConfirming } =
    useTossWidget()

  const handleClick = async () => {
    const result = await requestPayment()

    if (result) {
      confirmPayment(result)
    }
  }

  return (
    <>
      <Button
        size="large"
        fullWidth
        disabled={!isWidgetReady}
        onClick={handleClick}
      >
        {t('button.pay')}
      </Button>
      {isConfirming && <Spinner className="rounded-xl bg-black/20" />}
    </>
  )
}
